module.exports = __webpack_public_path__ + "img/music.899e46e7.svg";